<div [hidden]="!comments && hideIfEmpty" class="jbm-comment-box {{class}}" style="max-height: {{maxHeight}}">
   <i class="far fa-comment"></i>
   {{comments}}
   <button *ngIf="showEditButton" class="btn btn-sm round btn-primary ml-2" (click)="editComment()"><i class="far fa-comment"></i></button>
</div>
